var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "21", height: "20", viewBox: "0 0 21 20", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "title",
      null,
      "Events"
    ),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      React.createElement("path", { d: "M3.182 14.604l.632-.702.202.022a7.995 7.995 0 0 0 6.962 4.051c4.415 0 7.995-3.57 7.995-7.975 0-4.404-3.58-7.975-7.995-7.975-4.085 0-7.501 3.071-7.947 7.089l-.124.111H2l-.124-.137C2.338 4.444 6.266.875 10.978.875c5.052 0 9.147 4.085 9.147 9.125s-4.095 9.125-9.147 9.125a9.145 9.145 0 0 1-7.81-4.372l.014-.15z", stroke: "#494444", strokeWidth: ".25" }),
      React.createElement("path", { d: "M2.864 11.821l1.862-1.978A.5.5 0 0 0 4.362 9H.638a.5.5 0 0 0-.364.843l1.862 1.978a.5.5 0 0 0 .728 0z" }),
      React.createElement("path", { d: "M10 10l2-4M10 10l3 5", stroke: "#494444", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })
    )
  );
});